"use client";

import { useRef, useState } from "react";

export default function AutoplayVideo({ src, style, wrapperStyle }) {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(true);

  const toggle = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play();
      setPlaying(true);
    } else {
      video.pause();
      setPlaying(false);
    }
  };

  return (
    <div style={{ position: "relative", display: "block", width: "100%", ...wrapperStyle }}>
      <video ref={videoRef} src={src} autoPlay muted loop playsInline style={style} />
      <button
        type="button"
        onClick={toggle}
        aria-label={playing ? "Pause video" : "Play video"}
        className="px-video-toggle"
      >
        {playing ? (
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true">
            <rect x="2" y="1" width="2.6" height="10" />
            <rect x="7.4" y="1" width="2.6" height="10" />
          </svg>
        ) : (
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true">
            <path d="M2.5,1.1 10.5,6 2.5,10.9Z" />
          </svg>
        )}
      </button>
    </div>
  );
}
